import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import postAddPost from '../../../api/graphql/mutations/postAddPost';
import StructureLanguageTabs from '../DragAndDrop/StructureLanguageTabs';
import slugify from '../../../utils/slugify';
import checkPostSlugNameRepeated from '../../../utils/checkPostSlugNameRepeated';
import Notificacion from '../../Notification';


const AddSubCategoryForm = (props) => {
  const initialState = {
    slugName: '',
    postName: '',
    postDescription: {
      title: {
        ca: '',
        es: '',
        en: '',
        pt: '',
      },
    },
    postCategory: [],
    type: 'sub-section',
    components: String(
      JSON.stringify([
        {
          type: 'Body',
          slugName: '',
          components: [],
        },
      ]),
    ),
  };

  const [postInfo, setPostInfo] = useState(initialState);
  const [status, setStatus] = useState({ status: 'creating', text: '' });

  useEffect(() => {}, []);

  const sendPost = async () => {
    if (postInfo.postDescription.title.en) {
      const slugNameRepeated = await checkPostSlugNameRepeated(`psc-${props.postCategory}-${slugify(postInfo.postName)}`);
      if (!slugNameRepeated) {
        console.log('creating...');
        const post = {
          ...postInfo,
          postName: postInfo.postName,
          slugName: `psc-${props.postCategory}-${slugify(postInfo.postName)}`,
          postCategory: [props.postCategory],
        };

        console.log('post', post);

        postAddPost(post)
          .then(({ isAdded }) => {
            if (!isAdded) {
              setStatus({ status: 'error', text: 'The category was not created' });
            } else {
              setStatus({ status: 'created', text: 'Ok', color: 'green' });
              props.reFetch();
            }
          })
          .catch(err => console.log(err));
      } else {
        setStatus({ status: 'error', text: 'Sub category already taken', color: 'red' });
      }
    }
  };

  const handleLangInput = (e) => {
    const { value, name } = e.target;
    const postState = {
      ...postInfo,
      postName: value,
      postDescription: {
        ...postInfo.postDescription,
        [name]: {
          en: value,
          es: value,
          ca: value,
          pt: value,
        },
      },
    };
    setPostInfo(postState);
  };

  const postTitle = postInfo.postDescription.title;
  const { handleClick } = props;
  return (
    <div className="category-create p-6">
      <div className="bg-greyWithinForm p-4 rounded-t-lg">
        <span className="font-americaMonoBold text-sm uppercase text-white">Create Sub Category</span>
      </div>
      <div className="bg-greyFilter text-white pb-4 flex flex-wrap w-full rounded-b-lg">
        <label className="font-americaMonoRegular text-xs uppercase bg-greyFilter text-black py-4 flex flex-wrap w-full px-5 rounded-b-lg pb-1" htmlFor="postTitle">
          Title
          <input className="font-americaMonoRegular p-2 bg-white outline-none w-full mt-4 rounded-full mb-3" onChange={handleLangInput} name="title" type="text" value={postTitle.en} />
        </label>
      </div>
      <div className="flex justify-between py-4 p-4">
        <Notificacion text={status.text} color={status.color} />
        <div>
          <button className={`mr-2 font-americaMonoBold text-xs px-6 py-2 bg-black border border-white rounded-full ${!postTitle.en ? 'text-grey' : 'text-white'} uppercase`} onClick={handleClick} type="button">
            Cancel
          </button>
          <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-greyFilter text-black uppercase -mr-4" onClick={sendPost} type="button" disabled={!postTitle.en}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

AddSubCategoryForm.propTypes = {
  handleClick: PropTypes.func.isRequired,
  reFetch: PropTypes.func.isRequired,
  postCategory: PropTypes.string.isRequired,
};

export default AddSubCategoryForm;
